import React from "react";
import { Page } from "@sscs/ui";
import { getQueryStatus } from "@sscs/utils";
import { useGetWhoamiQuery } from "Services";
import GenerateAccessToken from "../../components/GenerateAccessToken/GenerateAccessToken";
import RevokeAllAccessTokens from "../../components/RevokeAllAccessTokens/RevokeAllAccessTokens";
import TokenTable from "../../components/TokenTable/TokenTable";
import { MAX_ACCESS_TOKENS_COUNT } from "../../constants";
import { useGetPersonalAccessTokensQuery } from "../../services/personalAccessTokens.api";

const PersonalAccessTokens = (): React.JSX.Element => {
  const { data: whoami } = useGetWhoamiQuery();

  const {
    isLoading,
    isFetching,
    isError,
    error,
    data = {
      tokens: [],
      match_count: 0,
    },
  } = useGetPersonalAccessTokensQuery(
    {
      userId: whoami?.user_id ?? "",
    },
    { skip: !whoami },
  );

  const isRevokeAllActionDisabled = data.tokens.length === 0;

  return (
    <Page.Root>
      <Page.Header
        title="Personal access tokens"
        actions={
          <>
            <RevokeAllAccessTokens isDisabled={isRevokeAllActionDisabled} />
            <GenerateAccessToken
              isDisabled={data.match_count === MAX_ACCESS_TOKENS_COUNT}
            />
          </>
        }
      />
      <Page.Body>
        <TokenTable
          tokens={data.tokens}
          status={
            whoami
              ? getQueryStatus({ data, isLoading, isFetching, isError, error })
              : { status: "LOADING" }
          }
        />
      </Page.Body>
    </Page.Root>
  );
};

export default PersonalAccessTokens;
